import { Helmet } from "react-helmet";
import Hero from "../../components/Hero/hero";
import Contact from "../../components/contact/contact";
import Footer from "../../components/footer/footer";
import { HeaderPortfolio } from "../../components/headerPortfolio/header";
import Main from "../../components/main/main";
import Tech from "../../components/technologie/tech";

import { useEffect, useState } from "react";

const HomePage = () => {
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 300) {
        setshowScrollBTN(true);
      } else {
        setshowScrollBTN(false);
      }
    });
  }, []);

  const [showScrollBTN, setshowScrollBTN] = useState(false);
  return (
    <div
      id="up"
      className="container"
      itemScope
      itemType="http://schema.org/WebPage"
    >
      <Helmet>
        <meta property="og:title" content="Mon Portfolio" />
        <meta
          property="og:description"
          content="Découvrez mes réalisations et compétences dans le développement web."
        />
        <meta
          property="og:image"
          content="https://aymanebouya.vercel.app/portfoCerc1.png"
        />
        <meta property="og:url" content={window.location.href} />
        {/* <meta property="og:url" content="https://aymanebouya.vercel.app/" /> */}
      </Helmet>
      <HeaderPortfolio itemProp="header" />
      <div className="divider" />
      <Hero itemProp="hero" />
      <div className="divider" />
      <Tech itemProp="technology" />
      <div className="divider" />
      <Main itemProp="mainContent" />
      <div className="divider" />
      <Contact itemProp="contact" />
      <div className="divider" />
      <Footer itemProp="footer" />
      <a
        style={{ opacity: showScrollBTN ? 1 : 0, transition: "1s" }}
        href="#up"
      >
        <button
          className="icon-keyboard_arrow_up scroll2Top"
          itemProp="backToTopButton"
        ></button>
      </a>
    </div>
  );
};

export default HomePage;
